(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bam-browser-sdk-sdkSession-util"));
	else if(typeof define === 'function' && define.amd)
		define(["bam-browser-sdk-sdkSession-util"], factory);
	else if(typeof exports === 'object')
		exports["btm-user-manager"] = factory(require("bam-browser-sdk-sdkSession-util"));
	else
		root["btm-user-manager"] = factory(root["bam-browser-sdk-sdkSession-util"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return 